import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = { class: "input-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Amount", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Item-Name", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, " Used to check whether the player has at least the specified amount of the specified item. Press F3+H ingame and hover an item to see its name. ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("input", {
          type: "number",
          onKeypress: _cache[1] || (_cache[1] = $event => (_ctx.inputTransformer($event, _ctx.action.amount))),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.amount = $event))
        }, null, 544), [
          [
            _vModelText,
            _ctx.action.amount,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_3
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.action.itemName = $event))
      }, null, 512), [
        [_vModelText, _ctx.action.itemName]
      ])
    ]),
    _hoisted_6
  ]))
}